<template><div>

	<div class="view spec">

		<specsheet v-if="spec" :localspec="spec" />

		<div class="btn" @click="deleteSpec()">Slet</div>

		<inputfield label="Projekt">
			<select v-model="spec.project_key" @change="change('project_key',$event)">
				<option :value="project.key" v-for="(project,key,i) in all_projects">{{project.name}}</option>
			</select>
			<div class="select-arrow">▾</div>
		</inputfield>

		<btn full v-if="false" @click.native="save()" color="primary">Gem</btn>

	</div>

</div></template>

<script>
import fdb from '.././firebase_config.js'
import mixins from '../mixins.js'
import moment from 'moment'
import helpers from '../helpers.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Inputfield from '.././components/Inputfield'
import Specsheet from '.././components/Specsheet'
export default {
	components: { Box, Btn, Inputfield, Specsheet },
	mixins: [ mixins.db, mixins.generic ],
	data: function() {
		return {
			globals: this.$parent.globals,			
		}
	},
	computed: {

		spec_key(){ return this.$route.params.id },
		spec(){ return this.$store.getters['specs/getOne'](this.spec_key) },
		
		all_projects(){
			var p = this.$store.getters['projects/getAll']
			p = p.sort((a,b)=>{
				if(a.name < b.name) { return -1; }
				if(a.name > b.name) { return 1; }
				return 0;
			})
			return p
		},

	},
	methods: {

		deleteSpec(){
			if(!confirm('Sikker?')) return
			if(!confirm('Helt sikker?')) return
			fdb.ref('specs').child(this.spec.key).update({ archived:true })
			this.goto('/specs')
			this.toast('Opgavespecifikation slettet...')
		},		

		save() {

			globals.big_spinner = true
			var id = this.$route.params.id
			var data = JSON.parse(JSON.stringify(this.spec))

			delete data['.key']

			fdb.ref('specs').child(id).update(data)      
			
			eventBus.$emit('toast', {
				text: 'Saved'
			})
			globals.big_spinner = false
			eventBus.$emit('triggerIconSignal', 'thumbsup')
		},

	},

	created() {
		
		if( !this.is_admin ) this.goto('/')

	},
	
}
</script>



// WEBPACK FOOTER //
// Spec.vue?3c4067cc